<template>
  <input
    class="kd-input"
    :id="id"
    :type="type"
    :name="name"
    :value="value"
    :disabled="disabled"
    :required="required"
    :placeholder="placeholder"
    :maxlength="maxlength"
    :readonly="readonly"
    @focus="onFocus"
    @blur="onBlur"
    @input="onInput"
    @keydown.up="onInput"
    @keydown.down="onInput">
</template>

<script>
  import common from './common';
  import getClosestVueParent from '../../../utils/get-closest-vue-parent';

  export default {
    name: 'kd-input',
    props: {
      type: {
        type: String,
        default: 'text'
      }
    },
    mixins: [common],
    mounted() {
      this.$nextTick(() => {
        this.parentContainer = getClosestVueParent(this.$parent, 'kd-form__text-input');

        if (!this.parentContainer) {
          this.$destroy();

          throw new Error('You should wrap the kd-input in a kd-form__text-input');
        }

        this.parentContainer.inputInstance = this;
        this.setParentDisabled();
        this.setParentRequired();
        this.setParentPlaceholder();
        this.handleMaxLength();
        this.updateValues();
      });
    }
  };
</script>
